import { Link } from "gatsby"
import React from "react"
import {Navbar, NavDropdown, Nav} from 'react-bootstrap'
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles } from '@material-ui/core/styles';

/* importing page data */
import NavBarData from '../components/Page-Data/NavBarData.json';

/* importing image file */
import logo from '../images/logo.png';

const useStyles = makeStyles(() => ({
  navLinks:{
      textDecoration: 'none !important',
      listStyleType:'none',
      cursor: 'pointer !important',
      backgroundColor: '#003a4d !important',
      '&':{
          color:'#ffffff',
      },
      '& :hover':{
          color: '#f7941e !important',
      }
  },
}));

export default function Header(){

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  return(
  <Navbar collapseOnSelect expand="lg" fixed="top" className="navbarCustom">
  <Navbar.Brand><Link to={"/"} className="navbarItem1"><img src = {logo} alt="Logo" className="nav-icon"/></Link></Navbar.Brand>
  <Navbar.Toggle onClick={() => setExpanded((prevExpanded) => (prevExpanded = !prevExpanded))}
     aria-controls="responsive-navbar-nav"><span><MenuIcon style={{fontSize:40}}/>
     </span>
  </Navbar.Toggle>
  
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="navbar-items ml-auto">
      {NavBarData.map((item)=>{
        if(item["outerLink"] && item["outerLink"]==="1")
          return (<a className="navbarItem1" href={item["associatedLink"]} target="_blank" rel="noopener norefferer">{item["linkName"]}</a>)
        if(item["type"] === "NavLink")
          return ( <Nav><Link to={item["associatedLink"]} className="navbarItem1">{item["linkName"]}</Link></Nav> )
        else if(item["type"] === "DropdownLink")
        return(
        <NavDropdown 
          title={item["linkName"]} 
          id="collasible-nav-dropdown" 
          className="navbarItem1 dropdownPanel" 
          renderMenuOnMount={true}
        >
            {item["dropDownSource"].map((dropDownItem)=>{
              return(<NavDropdown.Item className={classes.navLinks} ><Link to={dropDownItem["associatedLink"]} className={classes.navLinks}>{dropDownItem["linkName"]}</Link><NavDropdown.Divider /></NavDropdown.Item>)
            })}
        </NavDropdown>
        )
      })}
    </Nav>
  </Navbar.Collapse>
</Navbar>
)
}

